import {
	GetPlayerTransactionsByIdRequest,
	GetPlayerTransactionsByIdResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerTransactionsById } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerTransactionsById(
	payload: GetPlayerTransactionsByIdRequest,
	props?: UseBaseQueryOptions<GetPlayerTransactionsByIdResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerTransactionsById, payload],
		queryFn: () => getPlayerTransactionsById(payload),
		...props,
	})
}
